export default {
  metaTitle: '评论列表',
  excludeSystemAutoGood: '排除系统自动好评',
  replyStatus: '回复状态',
  noReply: '未回复',
  replied: '已回复',
  tabBuyerReviews: '买家评价',
  tabPendingBuyerReviews: '待买家评价',
  contactBuyer: '联系买家',
  orderCompletedTime: '订单完成时间',
  autoGoodRemainingDays: '剩余评价天数',
  autoGoodReviewTip: '{days}天后默认好评',
  skuId: 'SKU#',
  operation: '操作',
  all: '全部',
  textContent: '文字内容',
  imageOrVideo: '图片或视频',
  stars: '星级',
  filter: '筛选',
  customerId: '买家编号',
  productName: '商品名称',
  orderSn: '订单号',
  listingId: 'Listing编号',
  star: '评分',
  imageAndVideo: '图片与视频',
  reviewTime: '评价时间',
  reply: '回复',
  replyColon: '回复：',
  replyPlaceholder: '请输入回复内容',
  replyTipEmpty: '请输入回复内容。',
  buyerIdMissing: '买家编号缺失'
}
